import { V2CoachmarkTour } from '@abyss/web/ui/Coachmark';
import React from 'react';

const CoachmarkStyling = {
  'abyss-coachmark-root': {
    width: '250px',
    marginTop: '8px',
    position: 'absolute' as const,
    left: '-700px',
    transform: 'none',
  },
  'abyss-coachmark-title': {
    fontSize: '14px',
  },
  'abyss-coachmark-content-container': {
    fontSize: '12px',
  },
};

type GuestPlanSelectionCoachmarkProps = {
  title: string;
  content: string;
  onClose: () => void;
};

export const GuestPlanSelectionCoachmark: React.FC<
  GuestPlanSelectionCoachmarkProps
> = ({ title, content, onClose }) => (
  <V2CoachmarkTour
    css={CoachmarkStyling}
    data-testid="guest-plan-selection-coachmark"
    onFinish={onClose}
    onSkip={onClose}
    startTour={true}
    steps={[
      {
        target: '#coachmark-anchor',
        title,
        description: content,
        position: 'bottom' as const,
      },
    ]}
    variant="gray"
  >
    <></>
  </V2CoachmarkTour>
);
